import o from "./index.es352.js";
import * as t from "./index.es353.js";
const r = {
  ...t,
  ...o
};
export {
  r as default
};
//# sourceMappingURL=index.es267.js.map
